import React from "react";

import Menu from "../nav/menu";
import Footer from "../nav/footer";
import useMedia from "use-media";
import LoginMobile from "./loginMobile.js";
import LoginDesktop from './loginDesktop.js';

function Login() {
  const isLargeScreen = useMedia("(min-width: 601px)");
  const isSmallScreen = useMedia("(max-width: 600px)");
  /*const screenSize = window.screen;
  const isTablet =
    screenSize.width >= 768 && screenSize.width < 1024 ? true : false;
  const isLaptop =
    screenSize.width >= 1024 && screenSize.width < 1440 ? true : false;
  const isLaptopL = screenSize.width >= 1440 ? true : false;
 
  let divSizeScreen = {};
  console.log(
    `Current state: isLaptopL=${isLaptopL}, isLaptop=${isLaptop}, isTable=${isTablet}`
  ); // Add this for debugging

  if (isTablet) {
    divSizeScreen.minHeight = "525px";
  } else if (isLaptop) {
    divSizeScreen.minHeight = "534px";
  } else if (isLaptopL) {
    divSizeScreen.minHeight = "450px";
  }*/

  return (
    <div>
      <Menu />
      <>
        {isLargeScreen && <LoginDesktop/>}
        {isSmallScreen && <LoginMobile/>}
      </>
      <Footer />
    </div>
  );
}

export default Login;
